import { debounce } from 'lodash'

export default {
  mounted(el) {
    el.addEventListener('focus', () => handler(el))
    el.addEventListener('blur', () => handler(el))
    observer.observe(el)
  },
}

const options = {
  root: document.querySelector('#scrollArea'),
  rootMargin: '0px',
  threshold: 1.0,
}

const callback = element => {
  element.forEach(el => {
    if (el.isIntersecting) {
      handler(el.target)
    }
  })
}

const observer = new IntersectionObserver(callback, options)

const handler = el => {
  el.style.height = '1px'
  el.style.height = el.scrollHeight + 'px'
}
